(function (root, factory) {
  const createPageTrackingPopupExposure = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = createPageTrackingPopupExposure;
    return;
  }

  if (root) {
    root.createPageTrackingPopupExposure = createPageTrackingPopupExposure;
  }
})(typeof window !== 'undefined' ? window : undefined, function createPageTrackingPopupExposureFactory() {
  const modalAfterShow = 'modal:afterShow';
  const drawerAfterShow = 'drawer:afterShow';

  return function createPageTrackingPopupExposure(core, options) {
    const currentOptions = options || {};
    const pageIdentity = currentOptions.pageIdentity || {
      pageName: '',
      subPageName: ''
    };

    function buildPopupExposureData(popupName, now) {
      return core.buildDataInfo({
        type: core.config.eventTypes && core.config.eventTypes.popupExposure,
        pageName: pageIdentity.pageName,
        subPageName: pageIdentity.subPageName,
        popupName: popupName
      }, now);
    }

    function reportPopupExposure(targetElement, sessionModule, sessionCallbacks) {
      let dataInfo;
      let nowMs;
      let popupName;

      if (!core.canTrack() || !core.config.eventTypes || !core.config.eventTypes.popupExposure) {
        return false;
      }

      if (typeof core.window.Shopify !== 'undefined' && core.window.Shopify.designMode) {
        return false;
      }

      if (core.utils.shouldSkipOverlayPopupTarget(targetElement)) {
        return false;
      }

      popupName = core.utils.resolvePopupHostDisplayName(targetElement);

      if (!popupName) {
        return false;
      }

      nowMs = Date.now();
      dataInfo = buildPopupExposureData(popupName, new Date(nowMs));

      if (sessionModule && typeof sessionModule.ensureActiveSession === 'function') {
        sessionModule.ensureActiveSession(nowMs, sessionCallbacks || {});
      }

      core.markActivity(nowMs);

      return core.sendTrackingEvent({
        basicInfo: core.buildBasicInfo(),
        dataInfo: dataInfo
      }, true);
    }

    function handleAfterShow(event, sessionModule, sessionCallbacks) {
      const targetElement = event && event.target;

      reportPopupExposure(targetElement, sessionModule, sessionCallbacks);
    }

    function bindPopupExposureEvents(sessionModule, sessionCallbacks) {
      if (!core.canTrack() || !core.config.eventTypes || !core.config.eventTypes.popupExposure) {
        return false;
      }

      core.document.addEventListener(modalAfterShow, function handleModalAfterShow(event) {
        handleAfterShow(event, sessionModule, sessionCallbacks);
      });

      core.document.addEventListener(drawerAfterShow, function handleDrawerAfterShow(event) {
        handleAfterShow(event, sessionModule, sessionCallbacks);
      });

      return true;
    }

    return {
      resolvePopupNameForElement: core.utils.resolvePopupHostDisplayName,
      shouldSkipTarget: core.utils.shouldSkipOverlayPopupTarget,
      reportPopupExposure,
      bindPopupExposureEvents
    };
  };
});
